<template>
  <div class="skeleton-card">
    <div class="skeleton-image"></div>
    <div class="skeleton-title"></div>
  </div>
</template>

<script>
export default {
  name: 'CardSkeleton'
}
</script>

<style scoped>
.skeleton-card {
  width: 100%;
  margin-bottom: 15px;
}

.skeleton-image {
  width: 100%;
  padding-top: 135%; /* Same as MusicCard */
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #f8f8f8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-title {
  margin-top: 10px;
  height: 16px;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #f8f8f8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style> 